import { ThreeDotsQuoteSendUpdates } from '@/main/components/shared/threeDotsQuote/options/threeDotsQuoteSendUpdates';
import { ThreeDotsQuoteCancelParts } from './options/threeDotsQuoteCancelParts';
import { ThreeDotsQuoteDirectAssign } from './options/threeDotsQuoteDirectAssign';
import { ThreeDotsQuoteHasOrderByClaim } from './options/threeDotsQuoteHasOrderByClaim';
import { ThreeDotsQuoteHistory } from './options/threeDotsQuoteHistory';
import { ThreeDotsQuoteImage } from './options/threeDotsQuoteImage';
import { ThreeDotsQuoteRequoteParts } from './options/threeDotsQuoteRequoteParts';
import { KogThreeDotsQuoteRoot } from './threeDotsQuoteRoot';

export default {
  Root: KogThreeDotsQuoteRoot,
  OptionImage: ThreeDotsQuoteImage,
  OptionHistory: ThreeDotsQuoteHistory,
  OptionHasOrderByClaim: ThreeDotsQuoteHasOrderByClaim,
  OptionRequoteParts: ThreeDotsQuoteRequoteParts,
  OptionCancelParts: ThreeDotsQuoteCancelParts,
  OptionDirectAssign: ThreeDotsQuoteDirectAssign,
  OptionSendUpdates: ThreeDotsQuoteSendUpdates
};
